module.exports = __webpack_public_path__ + "img/식품.6b098955.png";